import React from "react";
import {Checkbox, FormControlLabel} from "@mui/material";

interface CustomCheckboxProps {
  label:string;
  value:any;
  onChange: (checked: boolean) => void;
  is_disabled?: boolean;
  single_line_label?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({label, value, onChange, is_disabled=false, single_line_label=false}) => {

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value} // Dynamically bind to the `value` prop
          onChange={(e) => onChange(e.target.checked)} // Update the state when changed
          name={label} // Use `label` for dynamic naming
          disabled={is_disabled}
          sx={{
            '&.Mui-checked': {
              color: 'var(--naturGreen)', // Set color when checkbox is checked
            },
            '&:hover': {
              borderColor: 'var(--naturGreen)', // Set border color on hover
            }
          }}
        />
      }
      label={label}
      sx={single_line_label ? {whiteSpace: 'nowrap'} : {}}
    />
  );
};

export default CustomCheckbox;